export default __webpack_public_path__ + "media/flags/mh-38903f27.svg";